/*
 * *************************************
 * DO NOT MODIFY, FILE IS AUTO GENERATED
 * *************************************
 */

import { LoanFormat } from '../../models/LoanFormat';
import { LendingModel, PriceLevel } from '../../models/PriceTier';
import { AgeCategory } from '../../models/AgeCategory';
import { SubscriptionPeriodType } from '../../models/Article';
import { ProductClass } from './constants';

export enum AnalyseTypeEnum {
    LIST = 'LIST',
    BUNDLE = 'BUNDLE'
}

export enum LoanFormatEnum {
    EAUDIOBOOKS = 'EAUDIOBOOKS',
    EBOOKS = 'EBOOKS'
}

export enum CollectionTypeEnum {
    INDIVIDUAL = 'INDIVIDUAL',
    SHARED = 'SHARED'
}

export enum CatalogueSearchScope {
    CATALOGUE = 'CATALOGUE',
    EBOOKS = 'EBOOKS',
    EAUDIOBOOKS = 'EAUDIOBOOKS',
    LOTE = 'LOTE',
    LANGUAGE_LEARNING = 'LANGUAGE_LEARNING',
    EPRESS = 'EPRESS'
}

export enum CollectionSearchScope {
    ALL = 'ALL',
    EBOOKS = 'EBOOKS',
    EAUDIOBOOKS = 'EAUDIOBOOKS',
    EMAGAZINES = 'EMAGAZINES'
}

export interface AccountIn {
    code: string;
    customerMainAccount?: string;
    name?: string;
    type?: string;
}

export interface AccountOut {
    code: string;
    customerMainAccount: string;
    name?: string;
    standingOrders?: Array<StandingOrderOut>;
    type?: string;
}

export interface AggregationResponseEntryOut {
    buckets?: Array<BucketEntryOut>;
    more?: boolean;
    quicksearchQuery?: string;
    value?: string;
}

export interface AggregationResponseOut {
    aggregations?: {
        [key: string]: AggregationResponseEntryOut;
    };
    took?: number;
}

export interface AnalyseItem {
    amount?: number;
    name?: string;
    percentage?: number;
    genreId?: string;
}

export interface AnalyseOut {
    additionalCopies?: number;
    additionalCopiesPercentage?: number;
    ageCategory?: Array<AnalyseItem>;
    amount?: number;
    badges?: Array<AnalyseItem>;
    fiction?: number;
    fictionPercentage?: number;
    genres?: Array<AnalyseItem>;
    longQueue?: number;
    longQueuePercentage?: number;
    newProducts?: number;
    newProductsPercentage?: number;
    nonFiction?: number;
    nonFictionPercentage?: number;
}

export interface CompleteCollectionAnalyseOut {
    ageCategory: Array<AnalyseItem>;
    genres: Array<AnalyseItem>;
    fiction: number;
    fictionPercentage: number;
    nonFiction: number;
    nonFictionPercentage: number;
    totalCopies: number;
}

export interface AnalyseResponseOut {
    analyseType?: AnalyseTypeEnum;
    analyses: {
        EAUDIOBOOKS: AnalyseOut;
        EBOOKS: AnalyseOut;
        EPRESS: AnalyseOut;
    };
    id: string;
}

export interface CompleteCollectionAnalyseResponseOut {
    analyses: {
        EAUDIOBOOKS: CompleteCollectionAnalyseOut;
        EBOOKS: CompleteCollectionAnalyseOut;
        EPRESS: CompleteCollectionAnalyseOut;
    };
    id: string;
}

export interface AwardOut {
    category?: string;
    name?: string;
    position?: string;
    year?: number;
}

export interface Badge {
    filter?: {
        [key: string]: FilterSetting;
    };
    title?: string;
}

export interface BadgeResponse {
    infoBadges?: Array<Badge>;
    premiumBadges?: Array<Badge>;
    warningBadges?: Array<Badge>;
}

export interface BannerOut {
    imageUrl?: string;
    targetUrl?: string;
}

export interface BillToIn {
    block?: string;
    city?: string;
    name?: string;
    state?: string;
    street?: string;
    zip?: string;
}

export interface BucketEntry {
    buckets?: Array<BucketEntry>;
    custom?: boolean;
    customKey?: boolean;
    docCount?: number;
    inSelectedState?: boolean;
    key?: string;
    noValueKey?: boolean;
    state?: string;
    value?: string;
}

export interface BucketEntryOut {
    buckets?: Array<BucketEntryOut>;
    custom?: boolean;
    customIndex?: number;
    docCount?: number;
    key?: string;
    state?: 'include' | 'exclude';
    value?: string;
}

export interface BulkQuantityFilterRequest {
    amount?: number;
    bundleRef?: string;
    excludedProductIds?: Array<string>;
    filterRequest?: {
        [key: string]: FilterSetting;
    };
    selectionListRef?: string;
}

export interface BulkQuantityIdRequest {
    amount?: number;
    bundleRef?: string;
    productIds?: Array<string>;
    selectionListRef?: string;
}

export interface BulkSourceFilterRequest {
    bundleRef?: string;
    excludedProductIds?: Array<string>;
    filterRequest?: {
        [key: string]: FilterSetting;
    };
    genreId?: string;
    loanFormat?: LoanFormatEnum;
    query?: string;
    refine?: string;
    selectionListRef?: string;
    sourceId?: string;
}

export interface BulkSourceIdRequest {
    bundleRef?: string;
    productIds?: Array<string>;
    selectionListRef?: string;
    sourceId?: string;
}

export interface BulkUsageConditionsUpdateRequest {
    updates?: Array<UsageConditionsUpdateRequest>;
}

export interface BundleCategoryEntryOut {
    buckets?: Array<BundleCategoryEntryOut>;
    custom?: boolean;
    docCount?: number;
    key?: string;
    state?: string;
    value?: string;
}

export interface BundleCategoryOut {
    buckets?: Array<BundleCategoryEntryOut>;
    key?: string;
}

export interface BundleCategoryResponseOut {
    aggregations?: {
        [key: string]: BundleCategoryOut;
    };
    took?: number;
    totalHits?: number;
}

export interface BundleOut {
    bundleId?: string;
    coverUrl?: string;
    currency?: string;
    customerPrice?: number;
    description?: string;
    loanFormat?: string;
    previewProducts?: Array<ProductOut>;
    price?: number;
    productAmount?: number;
    productStockAmount?: number;
    releaseDate?: number;
    salesTag?: string;
    savedPercentage?: number;
    savedValue?: number;
    title?: string;
}

export interface BundleQueryResponseOut {
    forAuthorIds?: {
        [key: string]: Array<BundleOut>;
    };
    forProductIds?: {
        [key: string]: Array<BundleOut>;
    };
}

export interface BundleResponseOut {
    hits?: Array<BundleOut>;
    took?: number;
    totalHits?: number;
}

export interface BundleSidebarOut {
    bundleId?: string;
    coverUrl?: string;
    currency?: string;
    customerPrice?: number;
    description?: string;
    loanFormat?: string;
    previewProducts?: Array<ProductOut>;
    price?: number;
    productAmount?: number;
    productStockAmount?: number;
    releaseDate?: number;
    salesTag?: string;
    savedPercentage?: number;
    savedValue?: number;
    sidebarTopHit?: boolean;
    title?: string;
}

export interface CampaignProductDetailsOut {
    salesEndDate?: number;
    standardProductId: string;
}

export interface CategoryItem {
    filter?: string;
    id?: number;
    name?: string;
    path?: string;
}

export interface CategoryOut {
    ageCategories?: Array<string>;
    id?: number;
    items?: Array<CategoryItem>;
    loanFormat?: string;
    name?: string;
    territories?: Array<string>;
}

export interface CopyPriceOut {
    basePrice?: number;
    currency?: string;
    netValue?: number;
    savedPercentage?: number;
    savedValue?: number;
}

export interface CreateSelectionListRequest {
    listName?: string;
}

export interface CumulativeLoansChartOut {
    fileContent?: string;
    totalLoans?: number;
}

export interface CumulativeUsersChartOut {
    fileContent?: string;
    registeredUsersPlus?: number;
    totalRegisteredUsers?: number;
}

export interface EntryPageFilterResponse {
    buckets?: Array<BucketEntry>;
    topBuckets?: Array<BucketEntry>;
}

export type ProductSpec = {
    sortBy?: string;
    loanFormat?: LoanFormat;
    filters?: {
        [key: string]: FilterSetting;
    };
    ageCategory?: AgeCategory;
};

export type LCProductGroupOut = {
    type?: 'lc-product-group' | 'product-group';
    id?: string;
    name?: string;
    title?: string;
    seeAllUrl?: string;
    loanFormat?: LoanFormat;
    productSpec?: ProductSpec;
};

export type BannerCategory = 'ENTRY_PAGE_SUB_BANNER' | 'CATEGORY_PAGE_TOP_BANNER' | 'ENTRY_PAGE_TOP_BANNER';
export type BannerSlider = {
    type?: 'banner';
    banners?: Array<BannerOut>;
    bannerCategory?: BannerCategory;
};

export type EntryPageItemOut = LCProductGroupOut | BannerSlider;

export interface EntryPageOut {
    entryPageItems?: Array<EntryPageItemOut>;
    id?: string;
    sidebar?: SidebarOut;
}

export interface FilterSetting {
    exclude?: Array<string>;
    excludeFilterValues?: Array<string>;
    include?: Array<string>;
    includeAll?: boolean;
    includeFilterValues?: Array<string>;
    quicksearchQuery?: string;
}

export interface FinancialYearOut {
    key?: number;
    value?: string;
}

export interface ForeignLanguageFeaturedPageResponse {
    bestsellers?: ProductsResponseOut;
    newReleases?: ProductsResponseOut;
}

export interface GenreEntry {
    buckets: Array<GenreEntry>;
    docCount: number;
    key: string;
    value: string;
}

export interface GenreOut {
    id?: string;
    name?: string;
    subGenres?: Array<SubGenreOut>;
}

export interface GenreSidebarOut {
    id?: string;
    name?: string;
    sidebarTopHit?: boolean;
    subGenres?: Array<SubGenreOut>;
}

export interface GenresResponse {
    buckets: Array<GenreEntry>;
    topBuckets: Array<GenreEntry>;
}

export interface InputStream {}

export interface InputStreamResource {
    description?: string;
    file?: any;
    filename?: string;
    inputStream?: InputStream;
    open?: boolean;
    readable?: boolean;
    uri?: URI;
    url?: URL;
}

export interface InvoiceOut {
    date?: string;
    invoiceId?: string;
    invoiceNumber?: string;
    invoiceType?: string;
}

export interface IsbnBulkRequest {
    isbns?: string;
}

export interface IsbnBulkResponseOut {
    response?: string;
    successful?: boolean;
}

export interface LanguageSidebarAggregationResponse {
    buckets?: Array<BucketEntry>;
}

export interface LineItemCopyOut {
    basePrice?: number;
    bundleTitle?: string;
    currency?: string;
    discountType?: string;
    id?: number;
    netValue?: number;
    price?: CopyPriceOut;
    savedPercentage?: number;
    savedValue?: number;
}

export interface LineItemKey {
    productId: string;
    usageCondition?: UsageCondition;
    subscriptionPeriodType?: SubscriptionPeriodType;
}

export interface LineItemWithCopyDetailsOut {
    availablePrices?: Array<ListProductPriceOut>;
    basePrice?: number;
    copies?: Array<LineItemCopyOut>;
    copyAmount?: number;
    currency?: string;
    lendingModel?: LendingModel;
    netValue?: number;
    price?: ListProductPriceOut;
    savedPercentage?: number;
    savedValue?: number;
    termLimit?: number;
    usageLimit?: number;
}

export interface ListGroupedByBundleOut {
    basePrice?: number;
    bundleId?: string;
    catalogueBundleSize?: number;
    coverUrl?: string;
    currency?: string;
    description?: string;
    eaudiobookCopyAmount?: number;
    eaudiobookProductAmount?: number;
    eaudiobookProductStockAmount?: number;
    ebookCopyAmount?: number;
    ebookProductAmount?: number;
    ebookProductStockAmount?: number;
    loanFormat?: LoanFormatEnum;
    netValue?: number;
    salesTag?: string;
    savedPercentage?: number;
    savedValue?: number;
    title?: string;
}

export interface ListProductPriceOut {
    basePrice?: number;
    copyAmount?: number;
    copyBasePrice?: number;
    currency?: string;
    lendingModel?: LendingModel;
    netValue?: number;
    savedPercentage?: number;
    savedValue?: number;
    termLimit?: number;
    usageLimit?: number;
}

export interface PriceTierOut {
    lendingModel?: LendingModel;
    level?: PriceLevel;
}

export interface ListRequest {
    action?: string;
    amount?: number;
    bundleRef?: string;
    lendingModel?: LendingModel;
    selectionListRef?: string;
    source?: string;
    sourceId?: string;
    termLimit?: number;
    usageLimit?: number;
    sourceUsageCondition?: UsageCondition;
    targetUsageCondition?: UsageCondition;
    targetPrice?: PriceTierOut;
}

export interface MarcSettingsOut {
    autoDeliveryTrigger?: string;
    customerMainAccount?: string;
    deliveryMethod?: string;
    frequency?: string;
    frequencyDay?: string;
    sentWithInvoice?: boolean;
    splitAgeCategory?: string;
    splitFiction?: boolean;
    splitProductFormat?: boolean;
    splitRecordCount?: string;
    zip?: boolean;
}

export interface MarketingCampaignProductOut {
    ageCategory?: string;
    ageGroup?: string;
    authors?: Array<PerformerOut>;
    availablePrices?: Array<ProductPriceOut>;
    awards?: Array<AwardOut>;
    badges?: BadgeResponse;
    basePrice?: number;
    bestsellers?: Array<string>;
    campaignAvailable?: boolean;
    campaignCopies?: number;
    campaignDetails?: CampaignProductDetailsOut;
    campaignEnd?: string;
    campaignSalesStart?: string;
    campaignStart?: string;
    campaignStockAmount?: number;
    campaignTagLine?: string;
    combinedReserveInfo?: ReserveInfoOut;
    copyAmount?: number;
    copyBasePrice?: number;
    copyStockAmount?: number;
    coverUrl?: string;
    currency?: string;
    duration?: number;
    explicit?: boolean;
    fiction?: boolean;
    genres?: Array<GenreOut>;
    id?: string;
    illustrated?: boolean;
    isbn13?: string;
    language?: string;
    lendingModel?: LendingModel;
    lineItems?: Array<ProductPriceOut>;
    loanFormat?: string;
    loansLeft?: number;
    maxStartDate?: string;
    minStartDate?: string;
    narrators?: Array<PerformerOut>;
    netValue?: number;
    pages?: number;
    price?: ListProductPriceOut;
    productClass?: string;
    productionFormat?: string;
    publisher?: string;
    publisherImprint?: string;
    releaseDate?: number;
    releaseDatePostfix?: string;
    reserveAmount?: number;
    reviews?: Array<ReviewOut>;
    salesStatus?: SalesStatusOut;
    sampleURL?: string;
    savedPercentage?: number;
    savedValue?: number;
    selections?: Array<string>;
    seriesName?: string;
    seriesNumber?: number;
    simultaneousAccess?: boolean;
    stockDetails?: {
        [key: string]: StockDetails;
    };
    subTitle?: string;
    summary?: string;
    supplementaries?: Array<SupplementaryOut>;
    termLimit?: number;
    title?: string;
    titleWithoutPrefix?: string;
    totalLoans?: number;
    usageCondition?: string;
    usageLimit?: number;
    campaignUsageCondition: {
        lendingModel?: LendingModel;
        termLimit: number;
        usageLimit?: number;
    };
}

export interface MarketingCampaignProductSetPeriodRequest {
    campaignTagLine?: string;
    endDate?: string;
    startDate?: string;
}

export interface MarketingCampaignResponseOut {
    hits?: Array<MarketingCampaignProductOut>;
    took?: number;
    totalHits?: number;
}

export interface MarketingMaterialUrl {
    url?: string;
}

export interface MissingSeriesResponse {
    hits?: Array<SeriesProductGroup>;
    totalHits?: number;
}

export interface ModelFile {
    absolute?: boolean;
    absoluteFile?: any;
    absolutePath?: string;
    canonicalFile?: any;
    canonicalPath?: string;
    directory?: boolean;
    file?: boolean;
    freeSpace?: number;
    hidden?: boolean;
    name?: string;
    parent?: string;
    parentFile?: any;
    path?: string;
    totalSpace?: number;
    usableSpace?: number;
}

export interface OrderLineItemResponse {
    hits?: Array<OrderedLineItemOut>;
    took?: number;
    totalHits?: number;
}

export interface OrderOut {
    account?: AccountOut;
    standingOrder?: StandingOrderOut;
    billToBlock?: string;
    billToCity?: string;
    billToCountry?: string;
    billToName?: string;
    billToState?: string;
    billToStreet?: string;
    billToZip?: string;
    currency?: string;
    deliveredTo?: string;
    id: string;
    invoices?: Array<InvoiceOut>;
    netValue: number;
    orderDate?: number;
    purchaseOrderReference?: string;
    specialInstructions?: string;
    spocId: string;
    spocKey: string;
    spocName: string;
    spocType: string;
    status?: string;
    totalEAudiobookCopies: number;
    totalEAudiobooks: number;
    totalEBookCopies: number;
    totalEBooks: number;
    totalEPressCopies: number;
    totalEPress: number;

    totalTax: number;
    totalValue: number;
    version: number;
}

export interface OrderRequestIn {
    account: AccountIn;
    billTo?: BillToIn;
    purchaseOrderReference?: string;
    shoppingCartId?: string;
    shoppingCartVersion: number;
    specialInstructions?: string;
    standingOrder?: StandingOrderIn;
    totalValue: number;
}

export interface OrderedLineItemOut {
    authors?: Array<PerformerOut>;
    basePrice?: number;
    copyAmount?: number;
    copyBasePrice?: number;
    coverUrl?: string;
    currency?: string;
    id?: string;
    isbn13?: string;
    language?: string;
    lendingModel?: LendingModel;
    loanFormat?: LoanFormatEnum;
    narrators?: Array<PerformerOut>;
    netValue?: number;
    price?: ListProductPriceOut;
    productClass?: string;
    releaseDate?: number;
    salesStatus?: string;
    savedPercentage?: number;
    savedValue?: number;
    seriesName?: string;
    simultaneousAccess?: boolean;
    status?: Array<OrderedLineItemStatusOut>;
    termLimit?: number;
    title?: string;
    usageLimit?: number;
}

export interface OrderedLineItemStatusOut {
    amount?: number;
    invoice?: InvoiceOut;
    lendingModel?: LendingModel;
    status?: string;
    statusKey?: string;
    termLimit?: number;
    usageLimit?: number;
    preOrderShipDate: string; // e.g. "2016-11-03 00:00"
}

export interface OrdersResponse {
    orders?: Array<OrderOut>;
    totalCount?: number;
}

export interface PerformerOut {
    firstName?: string;
    id?: string;
    lastName?: string;
    name?: string;
    country?: string;
    website?: string;
    biography?: string;
    productAmount?: number;
    marcAuthorisedName?: string;
    photoUrl?: string;
}

export interface PerformerSidebarOut {
    firstName?: string;
    id?: string;
    lastName?: string;
    name?: string;
    sidebarTopHit?: boolean;
}

export interface ProductCopyDetails {
    collection?: string;
    collectionType?: CollectionTypeEnum;
    expiryDate?: number;
    invoice?: string;
    lineNumber?: number;
    orderNumber?: string;
    shipDate?: number;
    lendingModel?: string;
    startDate?: number;
    status?: string;
    termLimit?: number;
    usageCount?: number;
    usageLimit?: number;
    planStartDate?: number;
    planEndDate?: number;
    issueTitle?: string;
}

export interface ProductOut {
    ageCategory?: string;
    ageGroup?: string;
    authors?: Array<PerformerOut>;
    availablePrices?: Array<ProductPriceOut>;
    awards?: Array<AwardOut>;
    badges?: BadgeResponse;
    basePrice?: number;
    bestsellers?: Array<string>;
    campaignAvailable?: boolean;
    campaignDetails?: CampaignProductDetailsOut;
    campaignStockAmount?: number;
    combinedReserveInfo?: ReserveInfoOut;
    copyAmount?: number;
    copyBasePrice?: number;
    copyStockAmount?: number;
    coverUrl?: string;
    currency?: string;
    currentIssueId?: string;
    duration?: number;
    explicit?: boolean;
    fiction?: boolean;
    genres?: Array<GenreOut>;
    id?: string;
    illustrated?: boolean;
    isbn13?: string;
    language?: string;
    lendingModel?: LendingModel;
    lineItems?: Array<LineItemOut>;
    loanFormat?: string | LoanFormat;
    narrators?: Array<PerformerOut>;
    netValue?: number;
    pages?: number;
    price?: ListProductPriceOut;
    productClass?: ProductClass;
    productionFormat?: string;
    publisher?: string;
    publisherImprint?: string;
    releaseDate?: number;
    releaseDatePostfix?: string;
    reserveAmount?: number;
    reviews?: Array<ReviewOut>;
    salesStatus?: SalesStatusOut;
    sampleURL?: string;
    savedPercentage?: number;
    savedValue?: number;
    selections?: Array<string>;
    seriesName?: string;
    seriesNumber?: number;
    simultaneousAccess?: boolean;
    stockDetails?: StockDetails;
    subTitle?: string;
    summary?: string;
    supplementaries?: Array<SupplementaryOut>;
    termLimit?: number;
    title?: string;
    titleWithoutPrefix?: string;
    usageCondition?: string;
    usageLimit?: number;
}

export interface LineItemOut {
    readonly lineItemKey: string;
    readonly price: ListProductPriceOut;
    readonly availablePrices: ReadonlyArray<ListProductPriceOut>;
}

export interface ProductPriceOut {
    basePrice?: number;
    currency?: string;
    lendingModel?: LendingModel;
    netValue?: number;
    savedPercentage?: number;
    savedValue?: number;
    termLimit?: number;
    usageLimit?: number;
}

export interface ProductSearchResponseOut {
    currentRefine?: string;
    didYouMean?: string;
    hits?: Array<ProductOut>;
    refinedSearchCategories?: {
        [key: string]: string;
    };
    relatedResults?: SearchSidebarResponseOut;
    took?: number;
    totalHits?: number;
}

export interface ProductsResponseOut {
    hits?: Array<ProductOut>;
    took?: number;
    totalHits?: number;
}

export interface PromotionLinkResponse {
    promotionLinkSvg?: string;
    promotionLinkUrl?: string;
}

export interface PublisherSidebarOut {
    name?: string;
    sidebarTopHit?: boolean;
}

export interface QuicklinkOut {
    title?: string;
    url?: string;
}

export interface ReserveInfoOut {
    foreignReserveCount?: number;
    ownReserveCount?: number;
}

export interface ReserveListGenerate {
    reserveListId?: string;
}

export interface ReserveListCheckoutOut {
    billToBlock?: string;
    billToCity?: string;
    billToCountry?: string;
    billToName?: string;
    billToState?: string;
    billToStreet?: string;
    billToZip?: string;
    currency?: string;
    deliveredTo?: string;
    id: string;
    invoices?: Array<InvoiceOut>;
    invoiceId?: string;
    netValue: number;
    orderDate?: number;
    purchaseOrderReference?: string;
    specialInstructions?: string;
    spocId: string;
    spocKey: string;
    spocName: string;
    spocType: string;
    status?: string;
    totalEBooks: number;
    totalEAudiobooks: number;
    totalEBookCopies: number;
    totalEAudiobookCopies: number;
    totalTax: number;
    totalValue: number;
    version: number;
}

export interface ReserveListDefaultSettingsOut {
    approvalType?: string;
    emails?: Array<string>;
    generationDay?: string;
    generationInterval?: string;
    loanFormatDefaults?: {
        [key: string]: ReserveListLoanFormatDefaultSettingsOut;
    };
    separatedLoanFormatGeneration?: boolean;
}

export interface ReserveListDetailOut {
    date?: number;
    generatedWithDefaults?: boolean;
    id?: string;
    latestList?: boolean;
    loanFormatSettings?: {
        [key: string]: ReserveListSettingsOut;
    };
    orderNumber?: string;
    outdatedDueToGeneration?: boolean;
    outdatedDueToOrder?: boolean;
    status?: string;
    summary?: SummaryTotalsOut;
}

export interface ReserveListGenerationParams {
    copyFormula?: 'STANDARD' | 'PROACTIVE' | 'CUSTOM';
    maxCopies?: number | null;
    reserveRatio?: number;
}

export interface ReserveListGenerationRequest {
    generatedWithDefaults?: boolean;
    loanFormatDefaults?: {
        [key: string]: ReserveListGenerationParams;
    };
}

export interface CopiesListOut {
    copies: ReadonlyArray<LineItemCopyOut>;
}

export interface ReserveListItemSaveRequestIn {
    calculatedAmount?: number;
    foreignReserveQuantity?: number;
    foreignStockQuantity?: number;
    latestAmount?: number;
    loanQuantity?: number;
    ownReserveQuantity?: number;
    ownStockQuantity?: number;
    productId?: string;
    reserveListId?: string;
    reserveQuantity?: number;
    stockQuantity?: number;
}

export interface ReserveListLoanFormatDefaultSettingsOut {
    accountName?: string;
    copyFormula?: 'STANDARD' | 'CUSTOM' | 'PROACTIVE';
    maxCopies?: number | null;
    reserveRatio?: number;
    selected?: boolean;
}

export interface ReserveListOrderResponse {
    notOrderedLinkedReserveListId?: string | null;
    notOrderedLinkedReserveListLoanFormat?: string | null;
}

export interface ReserveListOut {
    date?: number;
    id?: string;
    orderNumber?: string;
    status?: string;
    summary?: SummaryTotalsOut;
}

export interface ReserveListProductOut {
    accepted?: boolean;
    ageCategory?: string;
    ageGroup?: string;
    authors?: Array<PerformerOut>;
    availableForSale?: boolean;
    availablePrices?: Array<ProductPriceOut>;
    awards?: Array<AwardOut>;
    badges?: BadgeResponse;
    basePrice?: number;
    bestsellers?: Array<string>;
    campaignAvailable?: boolean;
    campaignDetails?: CampaignProductDetailsOut;
    campaignStockAmount?: number;
    combinedReserveInfo?: ReserveInfoOut;
    copyAmount?: number;
    copyBasePrice?: number;
    copyStockAmount?: number;
    coverUrl?: string;
    currency?: string;
    duration?: number;
    explicit?: boolean;
    fiction?: boolean;
    genres?: Array<GenreOut>;
    id?: string;
    illustrated?: boolean;
    isbn13?: string;
    language?: string;
    lendingModel?: LendingModel;
    lineItems?: Array<ProductPriceOut>;
    loanFormat?: string;
    narrators?: Array<PerformerOut>;
    netValue?: number;
    pages?: number;
    price?: ListProductPriceOut;
    productClass?: string;
    productionFormat?: string;
    publisher?: string;
    publisherImprint?: string;
    releaseDate?: number;
    releaseDatePostfix?: string;
    reserveAmount?: number;
    reviews?: Array<ReviewOut>;
    salesStatus?: SalesStatusOut;
    sampleURL?: string;
    savedPercentage?: number;
    savedValue?: number;
    selections?: Array<string>;
    seriesName?: string;
    seriesNumber?: number;
    simultaneousAccess?: boolean;
    stockDetails?: {
        [key: string]: StockDetails;
    };
    subTitle?: string;
    summary?: string;
    supplementaries?: Array<SupplementaryOut>;
    termLimit?: number;
    title?: string;
    titleWithoutPrefix?: string;
    usageCondition?: string;
    usageLimit?: number;
}

export interface ReserveListProductResponseOut {
    hits?: Array<ReserveListProductOut>;
    took?: number;
    totalHits?: number;
}

export interface ReserveListRequest {
    action?: string;
    amount?: number;
}

export interface ReserveListSaveRequestIn {
    generatedByJob?: boolean;
    generatedWithDefaults?: boolean;
    params?: {
        [key: string]: ReserveListGenerationParams;
    };
    reserveListItems?: Array<ReserveListItemSaveRequestIn>;
    spocId?: string;
    username?: string;
}

export interface ReserveListSettingsOut {
    copyFormula?: 'STANDARD' | 'PROACTIVE' | 'CUSTOM';
    maxCopies?: number;
    reserveRatio?: number;
}

export interface ReviewOut {
    content?: string;
    reviewSource?: string;
    reviewType?: string;
}

export interface SalesStatusOut {
    key?: string;
    value?: string;
}

export interface SearchSidebarResponseOut {
    authors?: Array<PerformerSidebarOut>;
    bundles?: Array<BundleSidebarOut>;
    genres?: Array<GenreSidebarOut>;
    narrators?: Array<PerformerSidebarOut>;
    publishers?: Array<PublisherSidebarOut>;
}

export interface SearchSuggestionResponseOut {
    suggestions?: {
        [key: string]: ProductSearchResponseOut;
    };
    topHits?: Array<TopHitOut>;
}

export interface SelectionListCommentOut {
    admin?: boolean;
    comment?: string;
    creDat?: number;
    editLog?: boolean;
    id?: number;
    modDat?: number;
    userId?: string;
    userName?: string;
}

export interface SelectionListOut {
    comingSoonProductsAmount?: number;
    currency?: string;
    eaudiobooksAmount?: number;
    eaudiobooksProductAmount?: number;
    eaudiobooksValue?: number;
    epressAmount?: number;
    epressProductAmount?: number;
    epressValue?: number;
    ebooksAmount?: number;
    ebooksProductAmount?: number;
    ebooksValue?: number;
    id?: string;
    lastModifiedAt?: number;
    listName?: string;
    shared?: boolean;
    totalNetValue?: number;
    totalTaxValue?: number;
    totalValue?: number;
    unavailableProductsAmount?: number;
}

export interface SeriesProductGroup {
    filterMap?: {
        [key: string]: FilterSetting;
    };
    loanFormat?: LoanFormatEnum;
    productCount?: number;
    seriesName?: string;
    stockCount?: number;
}

export interface SidebarOut {
    quicklinks?: Array<QuicklinkOut>;
    titleOfMonth?: ProductOut;
    topEaudiobooks?: Array<ProductOut>;
    topEbooks?: Array<ProductOut>;
    topEpress?: Array<ProductOut>;
    languages?: Array<BucketEntry>;
}

export interface Site {
    contentOrdersAllowed?: boolean;
    currency?: string;
    customCopyFormulaExists?: boolean;
    distributionTerritory?: string;
    eaudiobooksStockAmount?: number;
    ebooksStockAmount?: number;
    id?: string;
    name?: string;
    partnerId?: string;
    partnerName?: string;
    selectable?: boolean;
    stockAmount?: number;
    taxCountry?: string;
    taxName?: string;
}

export interface Source {
    host?: string;
    path?: string;
    uri?: string;
    views?: Views;
}

export interface SpocContextChangeResponse {
    spocId?: string;
    spocName?: string;
}

export interface SpocHierarchyOut {
    contentOrdersAllowed?: boolean;
    currency?: string;
    customCopyFormulaExists?: boolean;
    distributionTerritory?: string;
    eaudiobooksStockAmount?: number;
    ebooksStockAmount?: number;
    id?: string;
    name?: string;
    selectable?: boolean;
    sites?: Array<Site>;
    stockAmount?: number;
    taxCountry?: string;
    taxName?: string;
}

export interface StandingOrderIn {
    planId: string;
    planName?: string;
}

export interface StandingOrderOut {
    planId: string;
    planName: string;
}

export interface StockDetails {
    [spocId: string]: {
        collectionName: string;
        spocName: string | null;
        usageConditions: {
            [usageCondition: string]: {
                overallStock?: number;
                campaignStock?: number;
            };
        };
    };
}

export interface PreOrderStockDetails {
    [spocId: string]: {
        collectionName: string;
        spocName: string;
        usageConditions: {
            [usageCondition: string]: number;
        };
    };
}

export interface SubGenreOut {
    id?: string;
    name?: string;
}

export interface SummaryTotalsOut {
    comingSoonProductsAmount?: number;
    currency?: string;
    eaudiobooksAmount?: number;
    eaudiobooksProductAmount?: number;
    eaudiobooksValue?: number;
    ebooksAmount?: number;
    ebooksProductAmount?: number;
    ebooksValue?: number;
    epressAmount?: number;
    epressProductAmount?: number;
    epressValue?: number;
    totalNetValue?: number;
    totalTaxValue?: number;
    totalValue?: number;
    unavailableProductsAmount?: number;
}

export interface SupplementaryOut {
    information?: string;
    source?: string;
    type?: string;
}

export interface TopHitOut {
    object?: any;
    tag?: string;
}

export interface TotalLoansChartOut {
    averageLoansDuringCampaign?: number;
    averageLoansPlus?: number;
    fileContent?: string;
}

export interface TotalViews {
    sources?: Array<Source>;
    total?: number;
}

export interface URI {
    absolute?: boolean;
    authority?: string;
    fragment?: string;
    host?: string;
    opaque?: boolean;
    path?: string;
    port?: number;
    query?: string;
    rawAuthority?: string;
    rawFragment?: string;
    rawPath?: string;
    rawQuery?: string;
    rawSchemeSpecificPart?: string;
    rawUserInfo?: string;
    scheme?: string;
    schemeSpecificPart?: string;
    userInfo?: string;
}

export interface URL {
    authority?: string;
    content?: any;
    defaultPort?: number;
    file?: string;
    host?: string;
    path?: string;
    port?: number;
    protocol?: string;
    query?: string;
    ref?: string;
    userInfo?: string;
}

export interface UnavailableProductOut {
    id: string;
    lineItemKey: LineItemKey;
    isbn13?: string;
    loanFormat?: string;
    nameOfFirstAuthor?: string;
    title?: string;
}

export interface UnavailableProductsInSelectionListResponse {
    withdrawnProducts?: Array<UnavailableProductOut>;
}

export interface UnavailableProductsResponse {
    comingSoonProducts?: Array<UnavailableProductOut>;
    withdrawnProducts?: Array<UnavailableProductOut>;
}

export interface UsageCondition {
    lendingModel?: LendingModel;
    termLimit?: number;
    usageLimit?: number;
}

// TODO Move to separate file, since this one is generated
export function serializeUsageCondition(usageCondition: UsageCondition) {
    return `${usageCondition.lendingModel ?? ''}-${usageCondition.usageLimit ?? ''}-${usageCondition.termLimit ?? ''}`;
}

export interface UsageConditionsUpdateRequest {
    lendingModel?: LendingModel;
    productId?: string;
    termLimit?: number;
    usageLimit?: number;
    sourceLendingModel?: LendingModel;
    sourceTermLimit?: number;
    sourceUsageLimit?: number;
}

export interface Views {
    number?: number;
    percentage?: number;
}

export interface ListContentApiResponse {
    readonly availabilityCheck?: AvailabilityCheckOut;
    readonly fallbackPriceTiers?: ReadonlyArray<FallbackPriceTierOut>;
    readonly unavailableProducts?: Array<ProductOut>;
    readonly preOrderedProducts?: Array<ProductOut>;
    readonly alreadyInListProducts?: Array<ProductOut>;
}

export interface BulkActionResponse {
    readonly availabilityCheck?: AvailabilityCheckOut;
    readonly fallbackPriceTiers?: ReadonlyArray<FallbackPriceTierOut>;
    readonly unavailableProducts?: Array<ProductOut>;
    readonly preOrderedProducts?: Array<ProductOut>;
    readonly alreadyInListProducts?: Array<ProductOut>;
}

export interface BulkAddProductsToShoppingCartResponse {
    readonly fallbackPriceTiers: ReadonlyArray<FallbackPriceTierOut>;
    readonly unavailableProducts: Array<ProductOut>;
    readonly preOrderedProducts: Array<ProductOut>;
    readonly alreadyInListProducts: Array<ProductOut>;
}

export interface BulkAddProductsToSelectionListResponse {
    readonly fallbackPriceTiers: ReadonlyArray<FallbackPriceTierOut>;
    readonly alreadyInListProducts: Array<ProductOut>;
}

export interface AddSingleProductToShoppingCartResponseOut {
    readonly alreadyInListProduct: ProductOut;
    readonly preOrderedProduct: ProductOut;
}

export interface SingleActionResponse {
    readonly alreadyInListProducts: Array<ProductOut>;
    readonly preOrderedProducts: Array<ProductOut>;
}

export interface AddSingleProductToSelectionListResponseOut {
    readonly alreadyInListProduct: ProductOut;
}

export interface EditListResponse {
    readonly preOrderedProducts?: Array<ProductOut>;
    readonly alreadyInListProducts?: Array<ProductOut>;
}

export interface AvailabilityCheckOut {
    readonly fallbackPriceTiers?: ReadonlyArray<FallbackPriceTierOut>;
}

export interface FallbackPriceTierOut {
    readonly priceTier?: string;
    readonly amount?: number;
}

export interface FeaturedPageOut {
    id: number;
    scopeId: number;
    label: string;
    loanFormat?: string | null;
    productGroupSlots?: FeaturedPageSlotOut[];
}

export interface FeaturedPageSlotOut {
    id: number;
    slot: number;
    lastEditedEpochMillis: number;
    active: boolean;
    productGroup?: ProductGroupOut;
    usageStatistics?: UsageStatisticsOut;
}

export interface ProductGroupOut {
    id: number;
    title: string;
    expirationInDays: number | null;
    listId: string;
    sorting: string;
}

export interface UsageStatisticsOut {
    eaudiobooksAmountOnSite: number;
    eaudiobooksLoanableOnSite: number;
    eaudiobooksOnLoanOnSite: number;
    ebooksAmountOnSite: number;
    ebooksLoanableOnSite: number;
    ebooksOnLoanOnSite: number;
    epressAmountOnSite: number;
    epressLoanableOnSite: number;
    epressOnLoanOnSite: number;
}

export type MappedProductGroup = {
    id: number;
    slot: number;
    lastEditedEpochMillis: number;
    active: boolean;
    usageStatistics?: UsageStatisticsOut;

    products: ProductOut[];

    // mapped product group onto root level
    productGroupId?: number;
    title?: string;
    expirationInDays?: number | null;
    listId?: string;
    sorting?: string;
};

export interface SaveOrderResponse {
    productGroupId: number;
    scopeId: number;
    productGroups: MappedProductGroup[];
}

type ExpiredAndActiveSubscriptions = {
    spocId: string;
    startDate: string;
    endDate: string;
    usageLimit: number;
};

export type SubscriptionsResponseOut = {
    subscriptions: {
        productId: string;
        title: string;
        coverUrl: string;
        activeSubscriptions: ExpiredAndActiveSubscriptions[];
        expiredSubscriptions: ExpiredAndActiveSubscriptions[];
        futureSubscriptions: ExpiredAndActiveSubscriptions[];
    }[];
    spocId: string;
};

export interface SubscriptionMetaOut {
    includesSharedCopies: boolean;
    currentSubscriptionPeriod: SubscriptionPeriod;
    nextSubscriptionPeriod: SubscriptionPeriod;
}

export interface SubscriptionPeriod {
    type: 'CURRENT' | 'NEXT';
    startDate: string;
    endDate: string;
    lengthInDays: number;
}

export interface SubscriptionManagementPageDataOut {
    hits: ProductEntry[];
    totalHits: number;
}

export interface ProductEntry {
    product: ProductOut;
    currentSubscriptions?: SubscriptionInfoContainer;
    nextSubscriptions?: SubscriptionInfoContainer;
    renewal?: RenewalLineOut;
    patronSubscriptions: number;
    currentIssueStatistics: LoanStatisticsContainer;
    previousIssueStatistics: LoanStatisticsContainer;
    expired: boolean;
    expirationDate?: string;
}

export interface LoanStatisticsContainer {
    overview?: LoanStatisticsOverview | null;
    individual?: LoanStatisticsIndividual | null;
    shared?: LoanStatisticsShared | null;
}

export interface LoanStatisticsIndividual {
    loans: number;
    loansLeft: number | null;
    reserves: number;
    usagePercentage: number | null;
}

export interface LoanStatisticsOverview {
    ownLoans: number;
    foreignLoans: number | null;
    loansLeft: number | null;
    ownReserves: number;
    foreignReserves: number | null;
    usagePercentage: number | null;
}

export interface LoanStatisticsShared {
    ownLoans: number;
    foreignLoans: number;
    loansLeft: number | null;
    ownReserves: number;
    foreignReserves: number;
    usagePercentage: number | null;
}

export interface SubscriptionInfoContainer {
    individualUsageLimit?: number | null;
    sharedUsageLimit?: number | null;
    stockDetails: SubscriptionStockDetails;
}

export interface SubscriptionStockDetails {
    overview: StockDetails;
    individual?: StockDetails;
    shared?: StockDetails;
}

export interface RenewalLinesOut {
    renewalLines: RenewalLineOut[];
}

export interface RenewalLineOut {
    productId: string;
    types: SubscriptionRenewalTypeOut[];
    lineItems: LineItem[];
    totalUsageLimit?: number;
    totalPrice: number;
}

export interface SubscriptionRenewalTypeOut {
    type: string;
    selected: boolean;
    usageLimit?: number | null;
    enabled: boolean;
    infoMessage?: string;
}

export interface LineItem {
    price: ProductPriceOut;
    amount: number;
}

export interface SubscriptionRenewalLineItemUpdate {
    amount: number;
    usageCondition: UsageCondition;
}

export interface ShoppingCartMetaOut {
    id: string;
    spocId: string;
    spocType: string;
    spocKey: string;
    spocName: string;
    currency?: string;
    billToName?: string;
    billToStreet?: string;
    billToBlock?: string;
    billToCity?: string;
    billToState?: string;
    billToZip?: string;
    billToCountry?: string;
    totalEBooks: number;
    totalEAudiobooks: number;
    totalEPress: number;
    totalEBookCopies: number;
    totalEAudiobookCopies: number;
    totalEPressCopies: number;
    netValue: number;
    totalTax: number;
    totalValue: number;
    version: number;
}
